import AOS from "aos";
import "aos/dist/aos.css";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import "./home.scss";

function Home(props) {
	AOS.init({
		delay: 500,
		once: true
	});
	return (
		<div className="sec4">
			<div className="container">
				<div className="sec4Head">
					<h2 className="title" data-aos="">
						Laboratory
					</h2>
					<p data-aos="" data-aos-easing="linear" className="labSec4Text">
						GGI is the first laboratory in Pakistan to provide online verification of gemstone
						certificates. GGI laboratory is pioneer in Pakistan to seal diamonds and gemstones.
					</p>
				</div>
				<div className="stepsReport col-sm-12">
					<div className="innerSteps">
						<div className="stepDiv col-lg-3 col-md-6 col-xs-12 mt-5">
							<div className="innerStepDiv">
								<div className="iconDiv">
									<div className="innerIcon">
										<img
										alt="HandingOverDiamond_msj0lk.webp"
											data-src={
												"https://res.cloudinary.com/ggi/image/upload/v1637903426/HandingOverDiamond_msj0lk.webp"
											}
											className="serviceImage lazy"
											data-aos=""
											data-aos-delay={200}
										/>
									</div>
									<div className="badgeDiv" data-aos="" data-aos-delay={600}>
										01
									</div>
								</div>
								<div className="stepText" data-aos="" data-aos-easing="ease-in-back">
									<h4 data-aos="flip-" data-aos-easing="ease-out-cubic">
									 Secure Handoff
									</h4>
									<p data-aos="" data-aos-anchor-placement="top-bottom">
									<span  style={{ color:"black"}}>Customer Arrival:</span><br/>
									 When you visit our branch, our trained staff will greet you warmly. <br/>
									<span  style={{ color:"black"}}>Detailed Documentation:</span> <br/>
									We'll meticulously record your specific requirements and carefully inspect your valuables.
									</p>
								</div>
							</div>
							<div className="arrow arrowUp hideMob">
								<img
								alt="arrow_m9znvq.webp"
									className="arrowImage lazy"
									data-src={"https://res.cloudinary.com/ggi/image/upload/v1637903383/arrow_m9znvq.webp"}
								/>
							</div>
						</div>
						<div className="stepDiv col-lg-3 col-md-6 col-xs-12">
							<div className="innerStepDiv">
								<div className="iconDiv">
									<div className="innerIcon" style={{ overflow: "hidden" }}>
										<img
										alt="Recipt_New_uhfkub.webp"
											data-src={
												"https://res.cloudinary.com/ggi/image/upload/v1637903443/Recipt_New_uhfkub.webp"
											}
											className="serviceImage lazy"
											data-aos=""
											data-aos-delay={1000}
											style={{
												objectFit: "cover",
												objectPosition: "17px 26px",
												transform: "scale(1.7)"
											}}
										/>
									</div>
									<div className="badgeDiv" data-aos="" data-aos-delay={1400}>
										02
									</div>
								</div>
								<div className="stepText" data-aos="" data-aos-easing="ease-in-back">
									<h4 data-aos="flip-" data-aos-easing="ease-out-cubic">
									Secure Receipt
									</h4>
									<p data-aos="" data-aos-anchor-placement="top-bottom">
									<span  style={{ color:"black"}}>Peace of Mind:</span> <br/>
									 To ensure the safety of your precious items, we'll provide you with a detailed receipt. This receipt serves as a unique identifier for your valuables.
									</p>
								</div>
							</div>
							<div className="arrow arrowDown hideMob">
								<img alt="arrowdown_i6jpsz.webp"
									className="arrowImage lazy"
									data-src={
										"https://res.cloudinary.com/ggi/image/upload/v1637903384/arrowdown_i6jpsz.webp"
									}
								/>
							</div>
						</div>
						<div className="stepDiv col-lg-3 col-md-6 col-xs-12 mt-5">
							<div className="innerStepDiv">
								<div className="iconDiv">
									<div className="innerIcon">
										<img
										alt="GemstoneTesting_fr5xpb.webp"
											data-src={
												"https://res.cloudinary.com/ggi/image/upload/v1637903425/GemstoneTesting_fr5xpb.webp"
											}
											className="serviceImage lazy"
											data-aos=""
											data-aos-delay={1800}
											style={{
												objectFit: "cover",
												objectPosition: "left"
											}}
										/>
									</div>
									<div className="badgeDiv" data-aos="" data-aos-delay={2200}>
										03
									</div>
								</div>
								<div className="stepText" data-aos="" data-aos-easing="ease-in-back">
									<h4 data-aos="flip-" data-aos-easing="ease-out-cubic">
									 Expert Examination
									</h4>
									<p data-aos="" data-aos-anchor-placement="top-bottom">
									<span  style={{ color:"black"}}>State-of-the-Art Technology:</span><br/>
									 Our skilled gemologists utilize advanced equipment and techniques to thoroughly examine your gemstones.<br/>
									 <span  style={{ color:"black"}}>Precision and Accuracy:</span><br/>
									 Every aspect of your valuables, including their authenticity, quality, and value, is meticulously assessed.
									</p>
								</div>
							</div>
							<div className="arrow arrowUp hideMob">
								<img
								alt="arrow_m9znvq.webp"
									className="arrowImage lazy"
									data-src={"https://res.cloudinary.com/ggi/image/upload/v1637903383/arrow_m9znvq.webp"}
								/>
							</div>
						</div>
						<div className="stepDiv col-lg-3 col-md-6 col-xs-12">
							<div className="innerStepDiv">
								<div className="iconDiv">
									<div className="innerIcon">
										<img
										alt="diamondReport_xvjx7v.webp"
											data-src={
												"https://res.cloudinary.com/ggi/image/upload/v1637903399/diamondReport_xvjx7v.webp"
											}
											className="serviceImage lazy"
											data-aos=""
											data-aos-delay={2600}
										/>
									</div>
									<div className="badgeDiv" data-aos="" data-aos-delay={3000}>
										04
									</div>
								</div>
								<div className="stepText" data-aos="-zoom" data-aos-easing="ease-in-back">
									<h4 data-aos="flip" data-aos-easing="ease-out-cubic">
									 Authenticated Report
									</h4>
									<p data-aos="" data-aos-anchor-placement="top-bottom">
									<span  style={{ color:"black"}}>Comprehensive Evaluation:</span><br/>
									 Once the examination is complete, our experts will prepare a comprehensive authentication report.<br/>
									 <span  style={{ color:"black"}}>Transparency and Trust:</span><br/>
									 This report provides a detailed breakdown of your valuables, including their characteristics, value, and any relevant information.
									</p>
								</div>
							</div>
						</div>
					</div>

					<div className="buttonDiv" data-aos="" data-aos-anchor-placement="center-bottom">
					<Link to="/laboratory/about-ggi-laboratory">
						<button className="learnMore">
							Check Different Kinds of Lab Reports Available
						</button>
					</Link>
					</div>
				</div>
			</div>
		</div>
	);
}
const mapStateToProps = ({ store }) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Home));